import { createSearchAndFilterDisplayOptions, getDefaultRequestFields, mapSortAndFilter } from 'stores/adapters';
import { mapOmnitureData, mapSearchedDestination } from 'stores/adapters/bex-api/search/search-results-adapter';

import { HotelResultsViewModel } from 'models';

import { LodgingPwaPropertySearch, OperationResult } from '__generated__/api';

export const adaptPropertySearch = (bexApiResults: OperationResult<LodgingPwaPropertySearch.query>): HotelResultsViewModel => {
  const { data, extensions } = bexApiResults;

  if (!data || !data.propertySearch) {
    return {};
  }

  const { propertySearch } = data;

  const { summary } = propertySearch;

  const loyaltyInfo = summary && summary.loyaltyInfo;

  return {
    defaultRequestFields:
      getDefaultRequestFields(propertySearch.criteria, propertySearch?.shoppingContext?.multiItem?.id || '', bexApiResults) || undefined,
    propertySearchListings: propertySearch.propertySearchListings,
    propertyListingAdaptexAnalyticsSuccessEvents: propertySearch.propertyListingAdaptexAnalyticsSuccessEvents ?? [],
    loyaltyMessagingModel: loyaltyInfo,
    multiItemSearchContext: propertySearch.multiItemSearchContext || undefined,
    omnitureData: mapOmnitureData(extensions.analytics),
    searchAndFilterDisplayOptions: createSearchAndFilterDisplayOptions(propertySearch.sortAndFilter),
    searchedDestination: mapSearchedDestination(data),
    sortAndFilter: mapSortAndFilter(data?.propertySearch?.sortAndFilter),
    resultsSummary: summary.resultsSummary || undefined,
    resultMessages: summary.resultMessages,
    resultsHeading: summary.resultsHeading || undefined,
    totalPropertyCount: summary.matchedPropertiesSize,
    errorResponse: propertySearch.errorResponse || undefined,
    dialogErrorResponse: propertySearch.dialogErrorResponse || undefined,
    pagination: propertySearch.pagination || undefined,
    mapTrigger: propertySearch.mapTrigger || undefined,
  };
};
